
// CARPORTS > GETTERS

export default {
  currentProfile (state) {
    return state.profile
  }
}